import axios from 'axios';
import * as Config from '../../config';

const state = {
    typesInvoice: {},
    typeInvoice: {},
};

const actions = {

    load_TypesInvoice({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'type/invoice/list/all')
                .then(
                    response => {
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_TypeInvoice({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'type/invoice/consult/' + form.id)
                .then(
                    response => {
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    new_TypeInvoice({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'type/invoice/store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeActive_TypeInvoice({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'type/invoice/change/active/' + form.id + '/' + form.active)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_TypeInvoice({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'type/invoice/update/' + form.id, form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    }
};

const mutations = {

};

export default {
    state,
    actions,
    mutations
};